import moment from 'moment-timezone';

class DateRestriction {
    DRES_CUSTOM: string = 'custom';
    DRES_RANGE: string = 'range';
    DRES_WEEKDAYS: string = 'weekdays';
    DRES_FORMAT: string = 'YYYY-MM-DD';

    type: any = '';
    customDates: any = '';
    startDate: any;
    endDate: any;
    weekdays: any;

    constructor(dateRestrictionData:any) {
      this.type = dateRestrictionData && dateRestrictionData.type ? dateRestrictionData.type : false;

      let ctrl = this;

      switch( this.type ){
        case this.DRES_CUSTOM:
            this.customDates = dateRestrictionData.custom_dates.map((customDate:any) => {
                return moment( customDate ).format( ctrl.DRES_FORMAT );
            });
            break;

        case this.DRES_RANGE:
            this.startDate = moment(dateRestrictionData.start_date).startOf('day');
            this.endDate = moment(dateRestrictionData.end_date).endOf('day');
            break;

        case this.DRES_WEEKDAYS:
            this.weekdays = dateRestrictionData.weekdays.map((weekday:any) => {
                return weekday.toLowerCase();
            });
      }
    }

    /**
     * @desc determine type of recurrence and pass onto check dateRestriction for that specific type.
     * @param {moment.Moment}
     * @return {boolean}
     */
    isDateRestricted(dateToCheck:moment.Moment) : boolean {
        let ctrl = this;

        switch(this.type){
            case this.DRES_CUSTOM:
                return ctrl.isDateRestrictedCustomDates(this, dateToCheck);

            case this.DRES_RANGE:
                return ctrl.isDateRestrictedRange(this, dateToCheck);

            case this.DRES_WEEKDAYS:
                return ctrl.isDateRestrictedWeekdays(this, dateToCheck);

            default:
                return false;
        }
    }

    /**
     * @desc is date restricted for custom dates recurrence
     * @param {DateRestriction} dateRestriction
     * @param {moment.Moment} dateToCheck
     * @return {boolean}
     */
     isDateRestrictedCustomDates(dateRestriction:DateRestriction, dateToCheck:moment.Moment) : boolean {
        let checkDate = moment(dateToCheck).format(this.DRES_FORMAT);

        return dateRestriction.customDates.indexOf(checkDate) < 0;
    }

    /**
     * @desc is date restricted for date range recurrence
     * @param {DateRestriction} dateRestriction
     * @param {moment.Moment} dateToCheck
     * @return {boolean}
     */
     isDateRestrictedRange(dateRestriction:DateRestriction, dateToCheck:moment.Moment) : boolean {
        dateToCheck = moment(dateToCheck);

        return !dateToCheck.isBetween(dateRestriction.startDate, dateRestriction.endDate);
    }

    /**
     * @desc is date restricted for weekdays recurrence
     * @param {DateRestriction} dateRestriction
     * @param {moment.Moment} dateToCheck
     * @return {boolean}
     */
    isDateRestrictedWeekdays(dateRestriction:DateRestriction, dateToCheck:moment.Moment) : boolean {
        let checkDate = moment(dateToCheck).format('dddd').toLowerCase();

        return dateRestriction.weekdays.indexOf(checkDate) < 0;
    }
}

export default DateRestriction;